import React from "react";
import sanitizeHtml from "sanitize-html";
import { prepositions } from "../../libs/prepositons";

interface Props extends React.HTMLProps<HTMLDivElement> {
  html: string | null;
}

const HtmlParser = ({ html, ...htmlProps }: Props) => {
  if (html == null || html == "null") {
    return null;
  }

  const safeHtml = sanitizeHtml(prepositions(html));

  return <div {...htmlProps} dangerouslySetInnerHTML={{ __html: safeHtml }} />;
};

export default HtmlParser;
